//申诉结果：1：待审批，2：已通过，3：已拒绝 4：已撤销
export enum AppealStatus {
  AppealStatus_WaitApprove = 1, //待审批
  AppealStatus_Pass = 2, //已通过
  AppealStatus_Refuse = 3, //已拒绝
  AppealStatus_Cancel = 4, //已撤销
}
export const AppealStatusText = {
  [AppealStatus.AppealStatus_WaitApprove]: '审批中',
  [AppealStatus.AppealStatus_Pass]: '审批通过',
  [AppealStatus.AppealStatus_Refuse]: '审批拒绝',
  [AppealStatus.AppealStatus_Cancel]: '已撤销',
};

//绩效阶段code
export enum PerformanceStage {
  SelfEvaluation = 'self_evaluation', //绩效自评
  ConfirmColleague = 'confirm_colleague', //确认互评成员
  ColleagueEvaluation = 'colleague_evaluation', //同事互评
  LeaderEvaluation = 'leader_evaluation', //直属上级评估
  DepartmentEvaluation = 'department_evaluation', //部门负责人评估
  HRReview = 'hr_review', //hr审核
  CEOReview = 'ceo_review', //ceo审核
  HRSummary = 'hr_summary', //hr汇总
  Confirm = 'confirm', //员工确认
  Confirmed = 'confirmed', //员工已确认
}
export const PerformanceStageText: Record<string, string> = {
  [PerformanceStage.SelfEvaluation]: '绩效自评',
  [PerformanceStage.ConfirmColleague]: '确认互评人',
  [PerformanceStage.ColleagueEvaluation]: '同事互评',
  [PerformanceStage.LeaderEvaluation]: '直属上级评估',
  [PerformanceStage.DepartmentEvaluation]: '部门负责人评估',
  [PerformanceStage.HRReview]: 'HR审核',
  [PerformanceStage.CEOReview]: 'CEO审核',
  [PerformanceStage.HRSummary]: 'HR汇总',
  [PerformanceStage.Confirm]: '员工确认',
  [PerformanceStage.Confirmed]: '员工已确认',
};

//绩效状态  1: 待开启 2:进行中 2:已完成
export enum PerformanceStatus {
  PerformanceStatus_WaitStart = 1, //待开启
  PerformanceStatus_Doing = 2, //进行中
  PerformanceStatus_Finish = 3, //已完成
}

export const PerformanceStatusText = {
  [PerformanceStatus.PerformanceStatus_WaitStart]: '待开启',
  [PerformanceStatus.PerformanceStatus_Doing]: '进行中',
  [PerformanceStatus.PerformanceStatus_Finish]: '已完成',
};
export enum PerformanceCycle {
  PerformanceCycle_FirstHalfYear = 1, //上半年
  PerformanceCycle_SecondHalfYear = 2, //下半年
}
export const PerformanceCycleText = {
  [PerformanceCycle.PerformanceCycle_FirstHalfYear]: '上半年',
  [PerformanceCycle.PerformanceCycle_SecondHalfYear]: '下半年',
};
export enum PerformanceHandlerStatus {
  NotStart = 0, //未提交
  NotSubmit = 1, //未提交
  TempSave = 2, //暂存
  Submit = 3, //已提交
}
export const PerformanceHandlerStatusText = {
  [PerformanceHandlerStatus.NotSubmit]: '未开始',
  [PerformanceHandlerStatus.NotSubmit]: '待提交',
  [PerformanceHandlerStatus.TempSave]: '已暂存',
  [PerformanceHandlerStatus.Submit]: '已提交',
};
/** 等级 */
export const PerformanceLevels = ['S', 'A', 'B+', 'B', 'C'];
//异动类型  1:入职 2:转正 3:调岗 4:晋升 5:降级 6:离职
export enum MoveType {
  Entry = 1, //入职
  Regular = 2, //转正
  Change = 3, //跨部门异动
  Promote = 4, //晋升
  Demote = 5, //职级调整
  Resign = 6, //离职
  TransferJob = 7, //转岗
  PartTimeJob = 8, //兼职
  PartTimeDept = 9, //兼岗
  Second = 10, //借调
  Dispatch = 11, //外派
}
export const MoveTypeText = {
  [MoveType.Entry]: '入职',
  [MoveType.Regular]: '转正',
  [MoveType.Change]: '调动-跨部门异动',
  [MoveType.Promote]: '调动-晋升',
  [MoveType.Demote]: '调动-职级调整',
  [MoveType.Resign]: '离职',
  [MoveType.TransferJob]: '调动-转岗',
  [MoveType.PartTimeJob]: '兼职',
  [MoveType.PartTimeDept]: '兼岗',
  [MoveType.Second]: '借调',
  [MoveType.Dispatch]: '外派',
};

export enum PerformanceMonthStage {
  LeaderEvaluation = 'month_leader_evaluation', //部门主管评估
  DepartmentEvaluation = 'month_department_evaluation', //部门经理评估
  Confirmed = 'month_confirmed', // 结束
}

export const PerformanceMonthStageText: Record<string, string> = {
  [PerformanceMonthStage.LeaderEvaluation]: '部门主管评估',
  [PerformanceMonthStage.DepartmentEvaluation]: '部门经理评估',
  [PerformanceMonthStage.Confirmed]: '结束',
};
export const PerformanceMonthPieceStageText: Record<string, string> = {
  [PerformanceMonthStage.DepartmentEvaluation]: '部门经理评估',
};
//绩效考核规则 0:无规则 1:计时类 2:计件类
export enum PerformanceRule {
  Time = 1, //计时类
  Piece = 2, //计件类
}
export const PerformanceRuleText = {
  [PerformanceRule.Time]: '计时类',
  [PerformanceRule.Piece]: '计件类',
};
//绩效类型 1:半年度  2:月度
export enum PerformanceType {
  HalfYear = 1, //半年度
  Month = 2, //月度
}
export const PerformanceTypeText = {
  [PerformanceType.HalfYear]: '半年度',
  [PerformanceType.Month]: '月度',
};
export const PerformanceTypeLongText = {
  [PerformanceType.HalfYear]: '半年度绩效',
  [PerformanceType.Month]: '月度绩效',
};
